import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import CommonHeading from "../../components/commonComponents/commonHeading";
import ButtonComponents from "../../components/commonComponents/ButtonComponents";
import FundsBlock from "./FundsBlock";
import { useDispatch, useSelector } from "react-redux";
import {
  getFund,
  getTransactionHistory,
  TransactionHistoryItem,
} from "../../redux/slice/fundAndTransactionSlice";
import { useLocation, useNavigate } from "react-router-dom";
import NumberFormatter from "../../utils/NumberFormater";
import DateFormatter from "../../utils/DateFormater";
// @ts-ignore
import clockRewind from "../../assets/clockRewind.svg";
import { CircularProgress, Drawer } from "@mui/material";
import { Helmet } from "react-helmet";
import { getIsWiredTransfer } from "../../utils/config";
import { AppDispatch, RootState } from "../../redux/store";
import DynamicDialog from "../../components/DynamicDialogBox";
import { BackButton } from "../../components/commonComponents/BackButton";
const handleGenerateResponse = (status: any, style: any) => {
  const lowerCaseStatus = status.toLowerCase();
  if (lowerCaseStatus === "in progress" || lowerCaseStatus === "in-progress") {
    return <span style={{ color: "#3B3B3B", ...style }}>In-progress</span>;
  } else if (
    lowerCaseStatus === "failed" ||
    lowerCaseStatus === "rejected" ||
    lowerCaseStatus === "canceled"
  ) {
    return (
      <span style={{ color: "#EF233C", ...style, textTransform: "capitalize" }}>
        {status}
      </span>
    );
  } else {
    return <span style={{ color: "#28A745", ...style }}>{status}</span>;
  }
};
const ManageFunds: React.FC = () => {
  const handleNavigate = () => {
    const isWired = getIsWiredTransfer();
    if (isWired === "1") {
      navigate("/managefunds/add-fund-wire-transfer");
    } else {
      navigate("/managefunds/add-fund");
    }
  };
  const { loginInvestorId: investorId } = useSelector((store: RootState) => store.user);
  const { state } = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState({})
  const historyLoading = useSelector((store: RootState) => store.fund.historyLoading);
  const transactionHistory = useSelector((store: RootState) => store.fund.transactionHistory);
  const handleTransaction = async (id: string) => {
    dispatch(getFund(id)).unwrap();
    await dispatch(getTransactionHistory(id)).unwrap();
  };
  useEffect(() => {
    if (investorId) {
      handleTransaction(investorId);
    }
  }, [investorId]);

  const handleDetails = async(transactions_details:TransactionHistoryItem) => {
    setDetails(transactions_details)
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  const numberItemToShow = 5;
  return (
    <>
    <div className='flex justify-start items-center'>
    </div>
    <Box pb={8}>
      <Helmet>
        <title>{`xBid | Manage Funds`}</title>
        <meta name="description" content={``} />
      </Helmet>
      <CommonHeading
        sx={{ mb: 2, fontWeight: "600", fontSize: 22,mt:{sm:"20px",md:"0px",xs:"2px"} }}
        heading={"Account Balance"}
      />
      <FundsBlock />
      <CommonHeading
        sx={{ my: 2, fontWeight: "600", fontSize: 22 }}
        heading={"Manage Account"}
      />
      <Box
        p={2}
        bgcolor={"#fff"}
        borderRadius={1}
        display={"flex"}
        justifyContent={"space-between"}
      >
        <Box display={"flex"}>
          <ButtonComponents
            sx={{ px: { xs: 3, md: 2 }, fontSize: "14px", fontWeight: "500" }}
            label={"Add Funds"}
            onClick={handleNavigate}
          />
          {/* <ButtonComponents
          sx={{ px: { xs: 3, md: 2 }, fontSize: "14px", fontWeight: "500" }}
          label={"Add Funds"}
          onClick={() => navigate("/managefunds/add-fund-wire-transfer")}
        /> */}
        </Box>
        <Box display={"flex"} alignItems={"center"} gap={1}>
          {/* <ReplayIcon fontSize="small" />{" "} */}
          <Box display={{ md: "flex", xs: "none" }}>
            <img src={clockRewind} alt="" height={18} width={18} />
            <Box
              sx={{
                cursor: "pointer",
                textDecoration: "underline",
                fontSize: "14px",
                fontWeight: "500",
              }}
              onClick={() => {
                navigate("/managefunds/withdrawal-fund", {
                  state: { withdrawalRequest: true },
                });
              }}
            >
              Withdrawal Request
            </Box>
          </Box>
          <Box display={{ md: "none", xs: "flex" }}>
            <ButtonComponents
              sx={{ fontSize: "14px", fontWeight: "500" }}
              variant="contained"
              label={"Withdrawal Request"}
              onClick={() => {
                navigate("/managefunds/withdrawal-fund", {
                  state: { withdrawalRequest: true },
                });
              }}
            />
          </Box>
        </Box>
      </Box>
      <DynamicDialog open={open} onClose={onClose} payload={details} />
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <CommonHeading
          sx={{ my: 2, fontWeight: "600", fontSize: { md: 22, xs: 16 } }}
          heading={"Last 5 Transactions"}
        />
        <Box
          fontSize={{ xs: 14 }}
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: "500",
          }}
          onClick={() => navigate("/managefunds/transaction-history")}
        >
          View Full Transaction History
        </Box>

      </Box>

      <List
        role="list"
        sx={{
          width: "100%",
          display: "flex",
          bgcolor: transactionHistory.length < 1 ? "white" : "",
          p: 0,
          flexDirection: "column",
          alignItems: transactionHistory.length < 1 ? "center" : "",
          justifyContent: "center",
          rowGap: 1.25,
        }}
      >
        {historyLoading ? <div className={`w-full h-[250px] flex items-center justify-center`}>
          <CircularProgress sx={{ color: "#faaf19" }} />
        </div> : transactionHistory.length > 0 ? (
          transactionHistory.map(
            (item: TransactionHistoryItem, index) =>
              index < numberItemToShow && (
                <Box
                  bgcolor={"#fff"}
                  borderRadius={1}
                  key={index}
                  sx={{ boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.1)",cursor: "pointer"}}
                  onClick={() => handleDetails(item)}
                >
                  <ListItem sx={{ px: 3, py: 1.25 }}>
                    <ListItemText
                      sx={{ m: 0 }}
                      primary={
                        <Box display={"flex"} justifyContent={"space-between"}>
                          <Box  sx={{cursor:"pointer"}}>
                            <Typography
                              fontWeight={500}
                              color={"#3B3B3B"}
                              fontSize={{ md: 18 }}
                              variant="body2"
                            >
                              {item.description || item.Type}
                            </Typography>
                          </Box>
                          <Box
                            fontWeight={600}
                            color={"#3B3B3B"}
                            fontSize={{ md: 18 }}
                          >
                            $<NumberFormatter amount={item.amount} />
                          </Box>
                        </Box>
                      }
                      secondary={
                        <Box
                          display={"flex"}
                          mt={2}
                          justifyContent={"space-between"}
                        >
                          <Box>
                            <Typography
                              fontWeight={500}
                              color={"#3B3B3B"}
                              fontSize={{ md: 14 }}
                              variant="body2"
                            >
                              {item.CompletedAt ||
                                item.CreatedAt ||
                                (item.initiatedAt && (
                                  <DateFormatter
                                    date={
                                      item.CompletedAt ||
                                      item.CreatedAt ||
                                      item.initiatedAt
                                    }
                                  />
                                ))}
                            </Typography>
                          </Box>
                          <Box fontSize={{ md: 14 }}>
                            {handleGenerateResponse(item.status, {
                              fontSize: "inherit",
                              fontWeight: 500,
                              lineHeight: 1.5,
                            })}
                          </Box>
                        </Box>
                      }
                    />
                  </ListItem>
                </Box>
              )
          )
        ) : (
          <Typography fontWeight={"500"} color="#9FA4AB">
            {" "}
            No information available
          </Typography>
        )}
      </List>
    </Box>
    </>
  );
};

export default ManageFunds;
